import axios from 'axios';

export const SPEECH_TRANSCRIPTION_NOTIFY_EVENT = 'dataspeech:speech-transcription-notify';

export type SpeechTranscriptionNotifyDetail = {
	message: string;
	severity: 'warning' | 'error';
};

const RATE_LIMIT =
	'Çok sık sesli istek gönderildi. Lütfen kısa bir süre bekleyip tekrar deneyin.';

const GENERIC = 'Ses metne çevrilirken bir sorun oluştu. Lütfen tekrar deneyin.';

/** Sunucu 429 veya diğer hatalarda uygulama genelinde Snackbar tetikler. */
export function notifySpeechTranscriptionError(err: unknown): void {
	const status = axios.isAxiosError(err) ? err.response?.status : undefined;
	const detail: SpeechTranscriptionNotifyDetail =
		status === 429
			? { message: RATE_LIMIT, severity: 'warning' }
			: { message: GENERIC, severity: 'error' };
	window.dispatchEvent(
		new CustomEvent(SPEECH_TRANSCRIPTION_NOTIFY_EVENT, { detail }),
	);
}
